import { Component } from '@angular/core';
import {
  RetentionRule,
  DataRetentionService,
} from '@app/admin/services/data-retention.service';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
import { TranslationService } from '@services/translation.service';
@Component({
    selector: 'app-retention-rule-modal',
    templateUrl: './retention-rule-modal.component.html',
    styleUrl: './retention-rule-modal.component.scss',
    standalone: false
})
export class RetentionRuleModalComponent {
  constructor(
    private dataRetentionService: DataRetentionService,
    private dialogRef: ScaffoldDialogRef,
    private translationService: TranslationService
  ) {}

  _data: any;
  set data(value: any) {
    console.log('value', value);
    if (value?.hasOwnProperty('id')) {
      Object.assign(this.rule, value);
      if (value.effectiveDate) {
        this.effectiveDate = new Date(value.effectiveDate);
      }
      if (value.expirationDate) {
        this.expirationDate = new Date(value.expirationDate);
      }
    }
  }
  get data(): any {
    return this._data;
  }
  rule: RetentionRule = {
    description: '',
    effectiveDate: null,
    expirationDate: null,
    retentionPeriod: null,
    retentionType: 'COURSE',
    disabled: false,
  };

  retentionTypes = [
    {
      name: this.translationService.getTranslatedContent('course', 'Course'),
      value: 'COURSE',
    },
    {
      name: this.translationService.getTranslatedContent('user', 'User'),
      value: 'USER',
    },
  ];

  effectiveDate: Date;
  expirationDate: Date;

  loading = false;
  saving = false;
  create: any;

  save() {
    console.log('this.rule', this.rule);
    if (this.rule.id) {
      this.updateRetentionRule();
    } else {
      this.createRetentionRule();
    }
  }

  createRetentionRule() {
    this.dataRetentionService
      .addRetentionRule(this.rule as RetentionRule)
      .subscribe((res: any) => {
        this.dialogRef.close(true);
      });
  }

  updateRetentionRule() {
    this.dataRetentionService
      .updateRetentionRule(this.rule)
      .subscribe((res: any) => {
        this.dialogRef.close(true);
      });
  }

  setDate(event: Date, field: string) {
    console.log('event', event);
    if (field === 'effectiveDate') {
      this.rule.effectiveDate = this.effectiveDate.toISOString();
    } else {
      this.rule.expirationDate = this.expirationDate.toISOString();
    }
    console.log('this.effectiveDate', this.effectiveDate);
  }

  close() {
    this.dialogRef.close();
  }

  hasErrors() {
    return (
      this.rule.description.length === 0 ||
      this.rule.effectiveDate === null ||
      this.rule.retentionPeriod === null ||
      this.rule.retentionType === null
    );
  }

  createData(type: string) {
    this.dialogRef.close(this.rule);
  }
}
